import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SupplierService } from "./supplier.service";

const initialState = {
  suppliers: [],
  supplier: null,
  success: false,
  isLoading: false,
  error: null,
  message: null,
};

export const addSupplier = createAsyncThunk(
  "supplier/addSupplier",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _supplierService = new SupplierService();
      const response = await _supplierService.addSupplier(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSuppliers = createAsyncThunk(
  "supplier/getSuppliers",
  async (_, { rejectWithValue, getState }) => {
    try {
      const _supplierService = new SupplierService();
      const response = await _supplierService.getSuppliers();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSupplier = createAsyncThunk(
  "supplier/getSupplier",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _supplierService = new SupplierService();
      const response = await _supplierService.getSupplier(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateSupplier = createAsyncThunk(
  "supplier/updateSupplier",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _supplierService = new SupplierService();
      const response = await _supplierService.updateSupplier(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSupplier = createAsyncThunk(
  "supplier/deleteSupplier",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _supplierService = new SupplierService();
      const response = await _supplierService.deleteSupplier(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    reset: (state) => {
      state.success = false;
      state.isLoading = false;
      state.error = null;
      state.message = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(addSupplier.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(addSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.supplier = action.payload.data;
      state.message = action.payload.message;
    });

    builder.addCase(addSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getSuppliers.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSuppliers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.suppliers = action.payload;
    });

    builder.addCase(getSuppliers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getSupplier.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.supplier = action.payload;
    });

    builder.addCase(getSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(updateSupplier.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.supplier = action.payload.data;
      state.message = action.payload.message;
    });

    builder.addCase(updateSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteSupplier.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSupplier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.supplier = action.payload.data;
      state.message = action.payload.message;
    });

    builder.addCase(deleteSupplier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { reset } = supplierSlice.actions;
export default supplierSlice.reducer;
